module.exports = __webpack_public_path__ + "img/flag-green.626ad1fa.svg";